import { Injectable } from '@angular/core';
import { ControlByRequest } from '../model/control-by-request';
import { RestClientService } from '../../rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class ControlByRequestService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    getControlByRequestsByRequestId(requestId) {
        return this._restClientService.load<ControlByRequest[]>('control-by-request/control-by-requests-by-requestid?requestId='+requestId);
    }
        
    getListControlByRequest() {
        return this._restClientService.load<ControlByRequest[]>('control-by-request/control-by-requests');
    }
      
    getControlByRequestById(id) {
        return this._restClientService.load<ControlByRequest>('control-by-request/control-by-request-by-id/'+id);
    }

    putControlByRequest(controlByRequest: ControlByRequest) {
        return this._restClientService.put<void>('control-by-request/update-control-by-request', controlByRequest);
    }

    postControlByRequest(controlByRequest: ControlByRequest) {
        return this._restClientService.save<void>('control-by-request/add-control-by-request', controlByRequest);
    }
    
    deleteControlByRequest(id){
        return  this._restClientService.delete<void>('control-by-request/delete-control-by-request/'+id);
    }

}      

    